 import React from "react";

const emptyActivity = { title: "", title_np: "", content: "", content_np: "", date: "", location: "", status: "upcoming" };

export default function PoliticalActivitiesTab({ activities, setActivities }) {
    const upd = (i, key, val) => {
        const c = [...activities];
        c[i] = { ...c[i], [key]: val };
        setActivities(c);
    };
    const removeAt = (i) => setActivities(activities.filter((_, idx) => idx !== i));

    return (
        <div className="card shadow-sm mb-3">
            <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                <span>Activities & Events <small className="text-muted fw-normal">(shown in the “Recent Activities” section with filters and counts)</small></span>
                <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setActivities([{ ...emptyActivity }, ...activities])}>
                    <i className="bi bi-plus-lg me-1" />Add Activity
                </button>
            </div>
            <div className="card-body">
                {activities.length === 0 ? (
                    <p className="text-muted mb-0">No activities yet. Add rallies, meetings, visits or public programmes.</p>
                ) : activities.map((a, i) => (
                    <div className="border rounded p-3 mb-3" key={i}>
                        <div className="row g-2">
                            <div className="col-md-3">
                                <label className="form-label small text-muted">Date</label>
                                <input type="date" className="form-control form-control-sm" value={a.date || ""} onChange={(e) => upd(i, "date", e.target.value)} />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label small text-muted">Status</label>
                                <select className="form-select form-select-sm" value={a.status || "upcoming"} onChange={(e) => upd(i, "status", e.target.value)}>
                                    <option value="upcoming">Upcoming</option>
                                    <option value="completed">Completed</option>
                                </select>
                            </div>
                            <div className="col-md-5">
                                <label className="form-label small text-muted">Location</label>
                                <input className="form-control form-control-sm" placeholder="e.g. Butwal, Main Road" value={a.location || ""} onChange={(e) => upd(i, "location", e.target.value)} />
                            </div>
                            <div className="col-md-1 d-flex align-items-end">
                                <button type="button" className="btn btn-sm btn-outline-danger w-100" onClick={() => removeAt(i)}><i className="bi bi-trash" /></button>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label small text-muted">Title</label>
                                <input className="form-control form-control-sm" value={a.title || ""} onChange={(e) => upd(i, "title", e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label small text-muted">शीर्षक (Nepali)</label>
                                <input className="form-control form-control-sm" value={a.title_np || ""} onChange={(e) => upd(i, "title_np", e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label small text-muted">Details</label>
                                <textarea rows="2" className="form-control form-control-sm" value={a.content || ""} onChange={(e) => upd(i, "content", e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label small text-muted">विवरण (Nepali)</label>
                                <textarea rows="2" className="form-control form-control-sm" value={a.content_np || ""} onChange={(e) => upd(i, "content_np", e.target.value)} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}